import React from "react";
import propTypes from "prop-types";
import classnames from "classnames";

import Panel from "../panel/Panel";
import "./StepIndicator.scss";
import { createDataAttributes } from "../../utilities";

const StepIndicator = ({
  currentStep,
  totalSteps,
  className,
  dataAttrib,
  ...rest
}) => {
  if (currentStep < 1) {
    console.error("StepIndicator: 'currentStep' cannot be less than 1");
    return null;
  }
  if (currentStep > totalSteps) {
    console.error(
      "StepIndicator: 'currentStep' cannot be greater than 'totalSteps'"
    );
    return null;
  }
  if (totalSteps < currentStep) {
    console.error(
      "StepIndicator: 'totalSteps' cannot be less than 'currentStep'"
    );
    return null;
  }

  const classes = classnames(className, "uikit__step-indicator");
  const completedWidth = ((currentStep - 1) / (totalSteps - 1)) * 100;
  return (
    <Panel
      highlight="blue"
      className={classes}
      {...rest}
      {...createDataAttributes(dataAttrib)}
    >
      <div className="uikit__step-indicator__content">
        <div className="uikit__step-indicator__label">
          <span>Step</span>
          <span>{currentStep}</span>
          <span>of</span>
          <span>{totalSteps}</span>
        </div>
        <div className="uikit__step-indicator__bar">
          <span className="uikit__step-indicator__bar-inner">
            <span
              style={{ width: `${completedWidth}%` }}
              className="uikit__step-indicator__bar-completed"
            />
          </span>
        </div>
      </div>
    </Panel>
  );
};

StepIndicator.propTypes = {
  className: propTypes.string,
  dataAttrib: propTypes.arrayOf(Object),
  currentStep: propTypes.number.isRequired,
  totalSteps: propTypes.number.isRequired
};
StepIndicator.defaultProps = {};

export default StepIndicator;
